export default "__VITE_ASSET__c4a2a6da__"